const baseProps = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.6,
	strokeLinecap: "round",
	strokeLinejoin: "round",
};

export function IconPlus({ className }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className={className}>
			<path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" />
		</svg>
	);
}

export function IconAltArrow({ className }) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path d="M12.3704 15.8351L18.8001 9.20467C19.2013 8.79094 18.9581 8 18.4297 8H5.5703C5.04189 8 4.79869 8.79094 5.1999 9.20467L11.6296 15.8351C11.8427 16.055 12.1573 16.0549 12.3704 15.8351Z" />
		</svg>
	);
}

export function IconArrowRight({ className }) {
	return (
		<svg width="18" height="18" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M5 12h14M13 6l6 6-6 6" />
		</svg>
	);
}

export function IconClose({ className }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M6 6l12 12M18 6L6 18" />
		</svg>
	);
}

export function IconLinkedIn({ className }) {
	return (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8 10H5v9h3v-9zm-1.5-5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5zM19 19v-5.1c0-2.41-1.27-3.4-2.86-3.4-1.36 0-2.04.74-2.41 1.42v-1.22h-2.86v8.3h3v-4.6c0-1.21.46-2.07 1.61-2.07 1.13 0 1.52.85 1.52 2.07V19H19z" />
		</svg>
	);
}

/* ---------- Capability icons (stroked, line-style) ---------- */

export function IconAI({ className }) {
	return (
		<svg width="28" height="28" viewBox="0 0 24 24" {...baseProps} className={className}>
			<rect x="4" y="4" width="16" height="16" rx="3" />
			<path d="M8 8v8M8 12h4M16 8v8M16 12l-2 4M14 8l2 4" />
			<circle cx="2.5" cy="9" r="0.6" fill="currentColor" />
			<circle cx="2.5" cy="15" r="0.6" fill="currentColor" />
			<circle cx="21.5" cy="9" r="0.6" fill="currentColor" />
			<circle cx="21.5" cy="15" r="0.6" fill="currentColor" />
			<path d="M2.5 9h1.5M2.5 15h1.5M20 9h1.5M20 15h1.5" />
		</svg>
	);
}

export function IconCode({ className }) {
	return (
		<svg width="28" height="28" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M9 8l-4 4 4 4M15 8l4 4-4 4M13 6l-2 12" />
		</svg>
	);
}

export function IconChip({ className }) {
	return (
		<svg width="28" height="28" viewBox="0 0 24 24" {...baseProps} className={className}>
			<rect x="6" y="6" width="12" height="12" rx="2" />
			<rect x="9" y="9" width="6" height="6" rx="1" />
			<path d="M9 3v3M12 3v3M15 3v3M9 18v3M12 18v3M15 18v3M3 9h3M3 12h3M3 15h3M18 9h3M18 12h3M18 15h3" />
		</svg>
	);
}

export function IconLayers({ className }) {
	return (
		<svg width="28" height="28" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M12 3l9 5-9 5-9-5 9-5z" />
			<path d="M3 13l9 5 9-5" />
			<path d="M3 17l9 5 9-5" />
		</svg>
	);
}

export function IconAtom({ className }) {
	return (
		<svg width="28" height="28" viewBox="0 0 24 24" {...baseProps} className={className}>
			<circle cx="12" cy="12" r="2" fill="currentColor" />
			<ellipse cx="12" cy="12" rx="10" ry="4" />
			<ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(60 12 12)" />
			<ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(120 12 12)" />
		</svg>
	);
}

export function IconPalette({ className }) {
	return (
		<svg width="28" height="28" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4 10 9c0 3-2.5 4-5 4h-1.5a1.5 1.5 0 0 0-1.06 2.56l.31.31A1.5 1.5 0 0 1 13.69 20.6 1.7 1.7 0 0 1 12 22z" />
			<circle cx="7.5" cy="11" r="1" fill="currentColor" />
			<circle cx="11.5" cy="7" r="1" fill="currentColor" />
			<circle cx="16" cy="9" r="1" fill="currentColor" />
			<circle cx="17" cy="13.5" r="1" fill="currentColor" />
		</svg>
	);
}

/* ---------- Automation flow icons ---------- */

export function IconSearch({ className }) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...baseProps} className={className}>
			<circle cx="11" cy="11" r="7" />
			<path d="M21 21l-4.3-4.3" />
		</svg>
	);
}

export function IconBolt({ className }) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
		</svg>
	);
}

export function IconTrend({ className }) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M3 17l6-6 4 4 8-8" />
			<path d="M14 7h7v7" />
		</svg>
	);
}

/* ---------- Why-us icons ---------- */

export function IconStar({ className }) {
	return (
		<svg width="22" height="22" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M12 2l3 7 7 .5-5.5 4.5 2 7L12 17l-6.5 4 2-7L2 9.5 9 9l3-7z" />
		</svg>
	);
}

export function IconClock({ className }) {
	return (
		<svg width="22" height="22" viewBox="0 0 24 24" {...baseProps} className={className}>
			<circle cx="12" cy="12" r="9" />
			<path d="M12 7v5l3 2" />
		</svg>
	);
}

export function IconScale({ className }) {
	return (
		<svg width="22" height="22" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M4 4h16v6H4zM8 14h8v6H8z" />
			<path d="M12 10v4" />
		</svg>
	);
}

export function IconTarget({ className }) {
	return (
		<svg width="22" height="22" viewBox="0 0 24 24" {...baseProps} className={className}>
			<circle cx="12" cy="12" r="9" />
			<circle cx="12" cy="12" r="5" />
			<circle cx="12" cy="12" r="1.5" fill="currentColor" />
		</svg>
	);
}

/* ---------- Sellaris feature icons ---------- */

export function IconDocument({ className }) {
	return (
		<svg width="22" height="22" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" />
			<path d="M14 3v5h5" />
			<path d="M9 13h6M9 17h6M9 9h2" />
		</svg>
	);
}

export function IconHandshake({ className }) {
	return (
		<svg width="22" height="22" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M11 17l-2 2a2 2 0 0 1-2.83-2.83L9 13.34" />
			<path d="M9 11.34l3-3 4 4 3-3" />
			<path d="M5 8l3-3h4l3 3 4 4-2 2-3-3-4 4-3-3-2-2z" />
			<path d="M13 17l2 2a2 2 0 0 0 2.83-2.83L15 13.34" />
		</svg>
	);
}

export function IconBox({ className }) {
	return (
		<svg width="22" height="22" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M21 8l-9 4-9-4 9-4 9 4z" />
			<path d="M3 8v8l9 4 9-4V8" />
			<path d="M12 12v8" />
		</svg>
	);
}

export function IconApple({ className }) {
	return (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
		</svg>
	);
}

export function IconAndroid({ className }) {
	return (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M17.6 9.48l1.84-3.18a.4.4 0 0 0-.69-.4L16.84 9.1a11.41 11.41 0 0 0-9.69 0L5.25 5.9a.4.4 0 0 0-.69.4l1.84 3.18A10.71 10.71 0 0 0 1 18h22a10.71 10.71 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 7 15.25zm10 0A1.25 1.25 0 1 1 18.25 14 1.25 1.25 0 0 1 17 15.25z" />
		</svg>
	);
}

/* ---------- Flags (compact, drawn as SVG so they render the same on every OS) ---------- */

export function IconFlagUS({ className }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 16"
			width="22"
			height="16"
			className={className}
			aria-hidden="true"
		>
			<rect width="24" height="16" rx="2" fill="#fff" />
			<g fill="#b22234">
				<rect y="0" width="24" height="1.23" />
				<rect y="2.46" width="24" height="1.23" />
				<rect y="4.92" width="24" height="1.23" />
				<rect y="7.38" width="24" height="1.23" />
				<rect y="9.84" width="24" height="1.23" />
				<rect y="12.30" width="24" height="1.23" />
				<rect y="14.77" width="24" height="1.23" />
			</g>
			<rect width="9.6" height="8.61" fill="#3c3b6e" rx="1" />
			<g fill="#fff">
				<circle cx="2" cy="2" r="0.5" />
				<circle cx="4.5" cy="2" r="0.5" />
				<circle cx="7" cy="2" r="0.5" />
				<circle cx="3.25" cy="4" r="0.5" />
				<circle cx="5.75" cy="4" r="0.5" />
				<circle cx="2" cy="6" r="0.5" />
				<circle cx="4.5" cy="6" r="0.5" />
				<circle cx="7" cy="6" r="0.5" />
			</g>
			<rect width="24" height="16" rx="2" fill="none" stroke="rgba(0,0,0,0.06)" />
		</svg>
	);
}

export function IconFlagES({ className }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 16"
			width="22"
			height="16"
			className={className}
			aria-hidden="true"
		>
			<rect width="24" height="16" rx="2" fill="#aa151b" />
			<rect y="4" width="24" height="8" fill="#f1bf00" />
			<g transform="translate(5.5,7.2)" fill="#aa151b" stroke="#aa151b" strokeWidth="0.18">
				<rect x="0" y="0" width="3" height="2.4" rx="0.25" fill="#c8102e" />
				<rect x="0.4" y="0.5" width="2.2" height="0.45" fill="#f1bf00" />
				<rect x="0.4" y="1.3" width="2.2" height="0.45" fill="#f1bf00" />
			</g>
			<rect width="24" height="16" rx="2" fill="none" stroke="rgba(0,0,0,0.06)" />
		</svg>
	);
}

/* ---------- Contact icons ---------- */

export function IconMail({ className }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" {...baseProps} className={className}>
			<rect x="3" y="5" width="18" height="14" rx="2" />
			<path d="M3 7l9 6 9-6" />
		</svg>
	);
}

export function IconPhone({ className }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M22 16.92V21a1 1 0 0 1-1.1 1 19.86 19.86 0 0 1-8.66-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 3.07 4.1 1 1 0 0 1 4.07 3h4.09a1 1 0 0 1 1 .75 12.86 12.86 0 0 0 .7 2.81 1 1 0 0 1-.23 1L8 9a16 16 0 0 0 6 6l1.45-1.62a1 1 0 0 1 1-.23 12.86 12.86 0 0 0 2.81.7 1 1 0 0 1 .75 1z" />
		</svg>
	);
}

export function IconPin({ className }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" {...baseProps} className={className}>
			<path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12z" />
			<circle cx="12" cy="10" r="2.5" />
		</svg>
	);
}

export function IconGlobe({ className }) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" {...baseProps} className={className}>
			<circle cx="12" cy="12" r="9" />
			<path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
		</svg>
	);
}
